import { useState } from 'react';

import { api } from '../../../services/api';

const ToolsPanel = () => {
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');
  const [directPhone, setDirectPhone] = useState('');
  const [directMessage, setDirectMessage] = useState('');
  const [directSending, setDirectSending] = useState(false);
  const [directResult, setDirectResult] = useState<string | null>(null);

  const waLink = phone
    ? `https://wa.me/${phone.replace(/[^0-9]/g, '')}${message ? `?text=${encodeURIComponent(message)}` : ''}`
    : '';

  const handleDirectSend = async () => {
    if (!directPhone.trim() || !directMessage.trim()) return;
    setDirectSending(true);
    setDirectResult(null);
    try {
      const chat = await api.createChat({
        title: directPhone,
        phone: directPhone,
      });
      await api.sendMessage(chat.id, {
        content: directMessage,
        clientMessageId: `direct:${crypto.randomUUID()}`,
      });
      setDirectResult(`Bericht verzonden naar ${directPhone}`);
      setDirectPhone('');
      setDirectMessage('');
    } catch {
      setDirectResult('Verzenden mislukt. Controleer of WhatsApp is verbonden.');
    } finally {
      setDirectSending(false);
    }
  };

  return (
    <div className="tools-panel">
      <section className="tool-section">
        <h4>WhatsApp Link Generator</h4>
        <p className="tool-description small">
          Maak een WhatsApp klik-link met optioneel vooraf ingevuld bericht.
        </p>
        <label className="tool-field">
          <span>Telefoonnummer (E.164)</span>
          <input
            type="tel"
            value={phone}
            onChange={(event) => setPhone(event.target.value)}
            placeholder="+31612345678"
          />
        </label>
        <label className="tool-field">
          <span>Bericht (optioneel)</span>
          <textarea
            value={message}
            onChange={(event) => setMessage(event.target.value)}
            placeholder="Hallo! Ik wil graag contact opnemen…"
            rows={2}
            maxLength={4096}
          />
        </label>
        {waLink && (
          <div className="tool-output">
            <input type="text" readOnly value={waLink} onClick={(e) => e.currentTarget.select()} />
            <button
              type="button"
              className="button secondary small"
              onClick={() => void navigator.clipboard.writeText(waLink)}
            >
              Kopiëren
            </button>
          </div>
        )}
      </section>

      <section className="tool-section">
        <h4>Direct Bericht Versturen</h4>
        <p className="tool-description small">
          Maak direct een nieuwe chat en stuur een bericht — zonder de chatlijst te gebruiken.
        </p>
        <label className="tool-field">
          <span>Telefoonnummer (E.164)</span>
          <input
            type="tel"
            value={directPhone}
            onChange={(event) => setDirectPhone(event.target.value)}
            placeholder="+31612345678"
            pattern="^\+[1-9][0-9]{6,14}$"
          />
        </label>
        <label className="tool-field">
          <span>Bericht</span>
          <textarea
            value={directMessage}
            onChange={(event) => setDirectMessage(event.target.value)}
            placeholder="Schrijf je bericht…"
            rows={3}
            maxLength={4096}
          />
        </label>
        <button
          type="button"
          className="button primary small"
          disabled={directSending || !directPhone.trim() || !directMessage.trim()}
          onClick={handleDirectSend}
        >
          {directSending ? 'Versturen…' : 'Versturen'}
        </button>
        {directResult && (
          <p className={`notice small ${directResult.includes('mislukt') ? 'error' : 'success'}`}>
            {directResult}
          </p>
        )}
      </section>
    </div>
  );
};

export default ToolsPanel;
